import { readUserScopeCount } from "@/api";
import { useQuery } from "@tanstack/react-query";

interface IProps {
    /**
     * The ID of the user
     */
    userId: number;
}

/**
 * A cell component that displays the number of scopes for a user
 */
export const UserScopeCount = ({ userId }: IProps) => {
    const { data } = useQuery({
        queryKey: ["user-scope-count", userId],
        queryFn: () => readUserScopeCount(userId),
    });

    if (data) {
        return data.count === 0 ? "-" : data.count;
    }
};
